import useRouteName from "../../../../hooks/useRouteName";

const useFlyAnywhereRoute = () => {
  const routeName = useRouteName();
  return routeName === "fly-anywhere";
};

export default useFlyAnywhereRoute;
